import styled from 'styled-components'
import { theme, Row, Box, Input } from '@/client/components'
const { borders, color, font, space, breakpoint } = theme

export const ImportantThings = styled.div`
  padding: ${space.xl3} 0;
  background-color: ${color.grayscale.lighter};

  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.xl3} 0 ${space.xl4};
    background-color: ${color.grayscale.white};
  }
`

export const ImportantThingsInner = styled.div`
  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.xl3} ${space.xl};
    border-radius: ${borders.radius.xl};
    background-color: ${color.grayscale.lighter};
  }

  @media (min-width: ${breakpoint.xl}) {
    padding: ${space.xl4} ${space.xl3};
  }
`

export const ContentInfos = styled.div`
  @media (min-width: ${breakpoint.xl}) {
    display: grid;
    grid-template-columns: 2fr 1fr;
  }
`

export const Details = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space.md};
  margin-bottom: ${space.xl2};

  @media (min-width: ${breakpoint.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${breakpoint.xl}) {
    margin-bottom: 0;
  }
`

export const PdfBox = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: ${space.md};
  padding: ${space.sm} ${space.lg};
  background-color: ${color.grayscale.white};
  border-radius: ${borders.radius.md};

  &:hover {
    text-decoration: none;
  }
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: ${space.xl3};
  padding-right: ${space.lg};
  margin-right: ${space.lg};
  border-right: ${borders.sizes.sm} solid ${color.grayscale.light};
`

export const CollapseRow = styled(Row)`
  & .collapse-header-ch {
    padding: 2rem 0;
  }

  & .collapse-content-ch > div {
    padding-left: 0;
    padding-right: 0;
  }
`

export const CollapseContent = styled.div`
  color: ${color.text.weak};
  font-family: ${font.family.text};
  font-size: ${font.size.baseroot};
  line-height: ${font.lineHeight.md};
`

export const ImageWrapper = styled.div`
  max-width: 20rem;
  margin-bottom: ${space.xl2};

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`

export const WarningBox = styled(Box)`
  padding: ${space.lg};
  margin-bottom: ${space.xl};
  border-radius: 0;
  border-top-right-radius: 100px;
`

export const SummaryInfoWrapper = styled.div`
  padding: 2rem 0;
`
export const SummaryInfoBlock = styled.div`
  background: ${color.grayscale.lighter};
  padding: 1rem 0;
  & .summary-link-row {
    margin-bottom: 4rem;
  }
  @media (min-width: ${breakpoint.xl}) {
    padding: 6rem 0;
  }

  & .SummeryCol {
    @media (min-width: ${breakpoint.xl4}) {
      flex: 1 1 0 !important;
      max-width: none !important;
    }
  }
`

export const SummeryIcons = styled.div`
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  margin-bottom: 1rem;
  & p {
    width: 100%;
  }

  @media (min-width: ${breakpoint.xl}) {
    margin-bottom: 0;
  }
`
export const SummeryIcon = styled.div`
  text-align: center;
  margin-right: 0.5rem;
  & img {
    @media (min-width: ${breakpoint.xl}) {
      width: 48px;
    }
    width: 38px;
  }
  & p {
    width: 100%;
    font-size: ${font.size.mini};
  }
`
export const InlineLabel = styled.div`
  width: 100%;
  max-width: 100%;
  & p {
    width: 100%;
  }
  @media (min-width: ${breakpoint.xl}) {
    max-width: 364px;
  }
`

export const InlineImage = styled.div`
  padding: 0 1rem;
  border-right: 1px solid ${color.grayscale.grayscale};
`

export const InlineLabelEach = styled.div`
  width: 100%;
  display: flex;
  background: ${color.grayscale.white};
  align-items: center;
  padding: 1rem 0rem;
  border-radius: 0.5rem;

  margin-bottom: 1rem;
  & p {
    width: 100%;
  }
`

export const InlineText = styled.div`
  padding: 0 1rem;
  font-size: ${font.size.xxsmall};
  font-weight: ${font.weight.normal};
`
export const NumberSetWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`

export const NumberSetEach = styled.div<{ type?: string }>`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 0.2rem;

  & .icon {
    background: ${({ type }) => (type === 'Light' ? color.grayscale.lightBlueShade : color.grayscale.blue)};
    color: ${color.grayscale.white};
    padding: 0.6rem;
    font-family: ${font.family.text};
    font-weight: ${font.weight.bold};
    font-size: ${font.size.xsmall};
  }
`
export const ImageAligner = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const StructureLabel = styled.div`
  max-width: 450px;
  & p {
    color: ${color.grayscale.greyalpha};
  }
`
export const CountBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 17px;
  height: 17px;
  border-radius: 20px;
  margin-right: 0.5rem;
`
export const Search = styled(Input)`
  margin-bottom: ${space.xl3};
`

export const SearchIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0 ${space.sm};
  height: ${space.xl3};
  color: ${color.grayscale.black};

  &:hover {
    color: ${color.primary.pure};
  }
`
